import React from 'react';
var css = {
  "linearProgressBar": "rui-jLdCK",
  "text": "rui-owW1A",
  "bar": "rui-zYY0O",
  "backBar": "rui-aGQoR",
  "completeBar": "rui-Lc3zj"
};
import Heading from '../Heading/Heading';
var LinearProgressBar = function LinearProgressBar(_ref) {
  var _ref$total = _ref.total,
    total = _ref$total === void 0 ? 10 : _ref$total,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? 0 : _ref$fill,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text;
  var style = {
    width: "".concat(fill / total * 100, "%")
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css.linearProgressBar,
    "data-aut-id": "linearProgressBar"
  }, text && /*#__PURE__*/React.createElement("div", {
    className: css.text
  }, /*#__PURE__*/React.createElement(Heading, {
    color: "blackSecondaryText",
    fontWeight: "normal",
    type: "footnote"
  }, text)), /*#__PURE__*/React.createElement("div", {
    className: css.bar
  }, /*#__PURE__*/React.createElement("div", {
    className: css.backBar
  }), /*#__PURE__*/React.createElement("div", {
    className: css.completeBar,
    "data-aut-id": "completeBar",
    style: style
  })));
};
export default LinearProgressBar;